import { render } from "./FooterSocial.vue?vue&type=template&id=60656bae&scoped=true"
import script from "./FooterSocial.vue?vue&type=script&lang=js"
export * from "./FooterSocial.vue?vue&type=script&lang=js"

import "./FooterSocial.vue?vue&type=style&index=0&id=60656bae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60656bae"]])

export default __exports__